import { FC } from 'react';
import ReportDetails from '../../component/reportDetails/reportDetails';
import { createInterventionReportConfig } from '../../component/reportDetails/interventionReportConfig';
import { getInterventionReportsKebabOptions } from './interventionReportsHelper';
import { InterventionReportDetailsProps } from './interventionReports.type';
import { ReportDetailsConfig } from '../../component/reportDetails/reportDetails.types';

export const InterventionReportDetails: FC<InterventionReportDetailsProps> = (
  props,
) => {
  const config: ReportDetailsConfig = createInterventionReportConfig(
    props.interventionReport,
  );

  return (
    <ReportDetails
      config={config}
      onClose={props.onClose}
      onReviewAndSign={props.onReviewAndSign}
      kebabOptions={getInterventionReportsKebabOptions(props.interventionReport, null, 0)
        .filter((o) => o.label !== 'View')
        .map((o) => ({
          label: o.label,
          optionKey: o.label,
        }))}
      onKebabAction={props.onKebabAction}
    />
  );
};
